<template>
  <div class="l-m-templates">
    <el-dialog
      title="确认删除"
      custom-class="template-delete-dialog"
      v-model="isShowDeleteTemplateConfirm"
      width="380px"
      top="30vh"
      :show-close="false"
    >
      <span>是否删除该模板？</span>
      <template #footer>
        <span class="dialog-footer">
          <div class="dialog-footer-btns">
            <el-button size="mini" @click="isShowDeleteTemplateConfirm = false">取 消</el-button>
            <el-button size="mini" @click="handleConfirmDelete">确 定</el-button>
          </div>
        </span>
      </template>
    </el-dialog>

    <el-dialog
      title="编辑模板"
      custom-class="index-workbench-editTemplate-dialog"
      v-model="isShowEditTemplate"
      width="500px"
      top="30vh"
      :show-close="false"
    >
      <div class="add-template-info">
        <div class="add-template-info-item">
          <span class="info-label">模板名称：</span>
          <span class="info-value"
            ><el-input v-model="templateName" type="text" maxlength="20" size="mini"></el-input
          ></span>
        </div>
        <div class="add-template-info-item">
          <span class="info-label">是否公开：</span>
          <span class="info-value"
            ><el-radio-group v-model="templateType">
              <el-radio :label="1">私有</el-radio>
              <el-radio :label="2">公开</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div class="add-template-info-item">
          <span class="info-label">访问权限：</span>
          <span class="info-value"
            ><el-input
              v-model="templateAuth"
              placeholder="英文逗号分隔，为空允许任何权限访问。"
              type="text"
              maxlength="200"
              size="mini"
            ></el-input
          ></span>
        </div>
        <div class="add-template-info-item">
          <span class="info-label">模板数据：</span>
          <span class="info-value"
            ><el-radio-group v-model="isUpdateTemplateData">
              <el-radio :label="1">不更新模板数据</el-radio>
              <el-radio :label="2">将当前项目数据更新到模板</el-radio>
            </el-radio-group>
          </span>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <div class="dialog-footer-btns">
            <el-button size="mini" @click="isShowEditTemplate = false">取 消</el-button>
            <el-button size="mini" @click="handleEditTemplate">确 定</el-button>
          </div>
        </span>
      </template>
    </el-dialog>

    <el-container>
      <el-header height="40px">模板管理</el-header>
      <el-main>
        <div class="container-wrapper">
          <div class="public-templates" v-if="publicTemplates.length > 0">
            <div class="templates-header">公共模板</div>
            <div class="templates-body">
              <div class="templates-item" v-for="item in publicTemplates" :key="item.create_time">
                <div class="templates-item-image">
                  <img :src="item.image || '/img/project_overview.jpg'" alt="" />
                </div>
                <div class="templates-item-name">
                  {{ item.template_name }}
                </div>
                <el-button size="mini" class="apple-btn" @click="chooseTemplate(item)">应用模板</el-button>
              </div>
            </div>
          </div>
          <div class="private-templates" v-if="privateTemplates.length > 0">
            <div class="templates-header">自己的模板</div>
            <div class="templates-body">
              <div class="templates-item" v-for="item in privateTemplates" :key="item.create_time">
                <div class="templates-item-image">
                  <img :src="item.image || '/img/project_overview.jpg'" alt="" />
                </div>
                <div class="templates-item-name">{{ item.template_name }}</div>
                <i class="edit-template el-icon-edit" @click="handleReadyEdit(item)"></i>
                <i class="delete-template el-icon-delete" @click="handleReadyDelete(item.row_id)"></i>
                <el-button size="mini" class="apple-btn" @click="chooseTemplate(item)">应用模板</el-button>
              </div>
            </div>
          </div>
          <div v-if="publicTemplates.length === 0 && privateTemplates.length === 0">暂无模板</div>
          <!-- <div><el-button @click="applyTempleData" size="mini" class="apple-btn">Apply</el-button></div> -->
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { request } from '../../../common/request';
import Api from '../../../apis/api';
// @ is an alias to /src
export default {
  name: 'LMTemplates',
  components: {},
  data() {
    return {
      publicTemplates: [],
      privateTemplates: [],
      isUpdateTemplateData: 1,
      isShowDeleteTemplateConfirm: false,
      isShowEditTemplate: false,
      currentEditData: null,
      deleteId: '',

      templateAuth: '',
      templateType: '',
      templateName: '',

      temp: {
        isPublished: true,
        PublishConfig: {
          isUsePassWord: '1',
          PassWord: '123456',
          PublishUrl: 'http://bdds.likezou.com/#/deploy?pid=ZRhsSLGIK/5uiprpK46w1A==',
        },
        isHideAllCharts: false,
        Name: '百里竹海景区大数据分析展示系统',
        ScreenSize: {
          width: 1920,
          height: 1080,
        },
        ScreenRatio: {
          w_Ratio: 47,
          h_Ratio: 47,
          old_w_Ratio: 47,
          old_h_Ratio: 47,
        },
        CurrentScene: {
          id: 'G_eFNxHiq94UbsDl2EV8J',
          IconPath: '/img/styles/menusIcons/menuIcon3.png',
          OverViewImg: './img/scene/scene.png',
          SceneName: '票务数据',
          Background: {},
          Style: {},
          Charts: [
            {
              componentTitle: '柱状图1',
              componentName: 'Bar1Charts',
              componentOverViewImg: './img/charts/BarCharts/Bar1Charts.png',
              id: '4Kaojz52ERFmV5_eemAXM',
              style: {
                width: 511,
                height: 214.99999999999997,
                left: 354.90909090909105,
                top: 236.54545454545456,
              },
              isScaling: false,
              isMoving: false,
              propertyData: {
                titleText: {
                  value: '景区预约量按统计',
                  lable: '图表标题',
                  propertyComponentName: 'SingleInputor',
                },
                borderConfig: {
                  propertyComponentName: 'ChartsBorderConfiger',
                  value: {
                    borderComponentName: 'Charts1Border',
                  },
                },
                chartsColor: {
                  propertyComponentName: 'ArrayColorSelector',
                  value: {
                    chartColor: [
                      'rgba(26, 159, 110, 1)',
                      'rgba(229,115,63,1)',
                      'rgba(240,189,108,1)',
                      'rgba(237,214,102,1)',
                      'rgba(77,168,222,1)',
                      'rgba(25,168,164,1)',
                    ],
                    chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                  },
                },
                ChartsData: {
                  lable: '数据接入',
                  propertyComponentName: 'ChartsDataConfigor',
                  value: {
                    currenEntry: 'staticData',
                    apiData: {
                      apiUrl:
                        'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                      apiResponseQuery: 'data.forecasts',
                      isUseFilter: true,
                      apiFilter:
                        "\n          // 可以使用data访问api请求的响应结果        \nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                      isUseInterval: true,
                      apiInterval: 10,
                    },
                    staticData: {
                      seriesList: ['预约量'],
                      source: [
                        {
                          s: '预约量',
                          x: '2021-05-21',
                          y: '25',
                        },
                        {
                          s: '预约量',
                          x: '2021-05-22',
                          y: '26',
                        },
                        {
                          s: '预约量',
                          x: '2021-05-23',
                          y: '20',
                        },
                        {
                          s: '预约量',
                          x: '2021-05-24',
                          y: '27',
                        },
                      ],
                    },
                  },
                },
                posSize: {
                  lable: '位置尺寸',
                  propertyComponentName: 'ChartsPosSizeConfiger',
                  value: {
                    width: 511,
                    height: 215,
                    left: 354.90909090909105,
                    top: 236.5454545454546,
                  },
                },
                fontStyle: {
                  lable: '图表文字样式',
                  propertyComponentName: 'ChartsFontStyleConfiger',
                  value: {
                    titleSize: 16,
                    titleColor: '#ccc',
                    xAxisSize: 12,
                    xAxisColor: '#c3dbff',
                    yAxisSize: 12,
                    yAxisColor: '#c3dbff',
                  },
                },
                chartsGrid: {
                  lable: '图表定位',
                  propertyComponentName: 'ChartsGridConfiger',
                  value: {
                    left: '5%',
                    right: '5%',
                    bottom: '5%',
                    top: '12%',
                  },
                },
                showStatus: {
                  value: 'norm',
                },
                chartsOpicity: {
                  propertyComponentName: 'ChartsOpicityConfiger',
                  value: 1,
                },
                chartsAnimation: {
                  propertyComponentName: 'ChartsAnimationConfiger',
                  value: {
                    isUseAnimation: false,
                    isUseStaticRefresh: false,
                    staticRefreshIntervalTime: 3,
                  },
                },
              },
            },
            {
              componentTitle: '柱状图1',
              componentName: 'Bar1Charts',
              componentOverViewImg: './img/charts/BarCharts/Bar1Charts.png',
              id: 'F2AWsCG5Lj0uqbRKDSb0J',
              style: {
                width: 544.0606060606063,
                height: 206.84848484848487,
                left: 342.83549783549796,
                top: 39.268398268398265,
              },
              isScaling: false,
              isMoving: false,
              propertyData: {
                titleText: {
                  value: '景区预约量按月统计',
                  lable: '图表标题',
                  propertyComponentName: 'SingleInputor',
                },
                borderConfig: {
                  propertyComponentName: 'ChartsBorderConfiger',
                  value: {
                    borderComponentName: 'Charts1Border',
                  },
                },
                chartsColor: {
                  propertyComponentName: 'ArrayColorSelector',
                  value: {
                    chartColor: [
                      'rgba(223,65,56,1)',
                      'rgba(229,115,63,1)',
                      'rgba(240,189,108,1)',
                      'rgba(237,214,102,1)',
                      'rgba(77,168,222,1)',
                      'rgba(25,168,164,1)',
                    ],
                    chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                  },
                },
                ChartsData: {
                  lable: '数据接入',
                  propertyComponentName: 'ChartsDataConfigor',
                  value: {
                    currenEntry: 'staticData',
                    apiData: {
                      apiUrl:
                        'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                      apiResponseQuery: 'data.forecasts',
                      isUseFilter: true,
                      apiFilter:
                        "\n          // 可以使用data访问api请求的响应结果        \nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                      isUseInterval: true,
                      apiInterval: 10,
                    },
                    staticData: {
                      seriesList: ['预约量'],
                      source: [
                        {
                          s: '预约量',
                          x: '一月',
                          y: '251',
                        },
                        {
                          s: '预约量',
                          x: '二月',
                          y: '236',
                        },
                        {
                          s: '预约量',
                          x: '三月',
                          y: '220',
                        },
                        {
                          s: '预约量',
                          x: '四月',
                          y: '227',
                        },
                        {
                          s: '预约量',
                          y: '234',
                          x: '五月',
                        },
                        {
                          s: '预约量',
                          y: '234',
                          x: '六月',
                        },
                        {
                          s: '预约量',
                          y: '554',
                          x: '七月',
                        },
                        {
                          s: '预约量',
                          y: '333',
                          x: '八月',
                        },
                        {
                          s: '预约量',
                          y: '643',
                          x: '九月',
                        },
                        {
                          s: '预约量',
                          y: '336',
                          x: '十月',
                        },
                        {
                          s: '预约量',
                          y: '226',
                          x: '十一月',
                        },
                        {
                          s: '预约量',
                          y: '222',
                          x: '十二月',
                        },
                      ],
                    },
                  },
                },
                posSize: {
                  lable: '位置尺寸',
                  propertyComponentName: 'ChartsPosSizeConfiger',
                  value: {
                    width: 544.0606060606063,
                    height: 206.84848484848487,
                    left: 342.83549783549796,
                    top: 39.268398268398265,
                  },
                },
                fontStyle: {
                  lable: '图表文字样式',
                  propertyComponentName: 'ChartsFontStyleConfiger',
                  value: {
                    titleSize: 16,
                    titleColor: '#ccc',
                    xAxisSize: 12,
                    xAxisColor: '#c3dbff',
                    yAxisSize: 12,
                    yAxisColor: '#c3dbff',
                  },
                },
                chartsGrid: {
                  lable: '图表定位',
                  propertyComponentName: 'ChartsGridConfiger',
                  value: {
                    left: '5%',
                    right: '5%',
                    bottom: '5%',
                    top: '12%',
                  },
                },
                showStatus: {
                  value: 'norm',
                },
                chartsOpicity: {
                  propertyComponentName: 'ChartsOpicityConfiger',
                  value: 1,
                },
                chartsAnimation: {
                  propertyComponentName: 'ChartsAnimationConfiger',
                  value: {
                    isUseAnimation: false,
                    isUseStaticRefresh: false,
                    staticRefreshIntervalTime: 3,
                  },
                },
              },
            },
            {
              componentTitle: '柱状图3',
              componentName: 'Bar3Charts',
              componentOverViewImg: './img/charts/BarCharts/Bar3Charts.png',
              id: 'u8eoVRDtppTf9XsbsgwLW',
              style: {
                width: 324.23995052566494,
                height: 233.8775510204082,
                left: 10.224489795918373,
                top: 41.24489795918369,
              },
              isScaling: false,
              isMoving: false,
              propertyData: {
                titleText: {
                  value: '景区预约按年统计',
                  lable: '图表标题',
                  propertyComponentName: 'SingleInputor',
                },
                borderConfig: {
                  propertyComponentName: 'ChartsBorderConfiger',
                  value: {
                    borderComponentName: 'Charts1Border',
                  },
                },
                chartsColor: {
                  propertyComponentName: 'ArrayColorSelector',
                  value: {
                    chartColor: [
                      'rgba(254, 128, 205, 1)',
                      'rgba(30, 252, 122, 1)',
                      'rgba(63, 210, 239, 1)',
                      'rgba(34, 46, 57, 0.39)',
                    ],
                    chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                  },
                },
                ChartsData: {
                  lable: '数据接入',
                  propertyComponentName: 'ChartsDataConfigor',
                  value: {
                    currenEntry: 'staticData',
                    apiData: {
                      apiUrl:
                        'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                      apiResponseQuery: 'data.forecasts',
                      isUseFilter: true,
                      apiFilter:
                        "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                      isUseInterval: true,
                      apiInterval: 10,
                    },
                    staticData: {
                      seriesList: ['预约量'],
                      source: [
                        {
                          s: '预约量',
                          x: '2021',
                          y: '22345',
                        },
                      ],
                    },
                  },
                },
                posSize: {
                  lable: '位置尺寸',
                  propertyComponentName: 'ChartsPosSizeConfiger',
                  value: {
                    width: 324.23995052566494,
                    height: 233.8775510204082,
                    left: 10.224489795918373,
                    top: 41.24489795918369,
                  },
                },
                fontStyle: {
                  lable: '图表文字样式',
                  propertyComponentName: 'ChartsFontStyleConfiger',
                  value: {
                    titleSize: 16,
                    titleColor: '#ccc',
                    xAxisSize: 12,
                    xAxisColor: '#c3dbff',
                    yAxisSize: 12,
                    yAxisColor: '#c3dbff',
                  },
                },
                chartsGrid: {
                  lable: '图表定位',
                  propertyComponentName: 'ChartsGridConfiger',
                  value: {
                    left: '5%',
                    right: '5%',
                    bottom: '5%',
                    top: '12%',
                  },
                },
                showStatus: {
                  value: 'norm',
                },
                chartsOpicity: {
                  propertyComponentName: 'ChartsOpicityConfiger',
                  value: 1,
                },
                chartsAnimation: {
                  propertyComponentName: 'ChartsAnimationConfiger',
                  value: {
                    isUseAnimation: false,
                    isUseStaticRefresh: false,
                    staticRefreshIntervalTime: 5,
                  },
                },
              },
            },
            {
              componentTitle: '文字1',
              componentName: 'Others3Charts',
              componentOverViewImg: './img/charts/OthersCharts/Others3Charts.png',
              id: 'Ja0g5-GLIT-kwas3XXgyw',
              style: {
                width: 323,
                height: 130,
                left: 19,
                top: 298,
              },
              isScaling: false,
              isMoving: false,
              propertyData: {
                titleText: {
                  value: '图表标题',
                  lable: '图表标题',
                  propertyComponentName: 'SingleInputor',
                },
                scaleratio: {
                  value: '2',
                  lable: '组件缩放倍数',
                  propertyComponentName: 'SingleInputor',
                },
                borderConfig: {
                  propertyComponentName: 'ChartsBorderConfiger',
                  value: {
                    borderComponentName: 'Charts0Border',
                  },
                },
                chartsColor: {
                  value: {
                    chartColor: [
                      'rgba(223,65,56,1)',
                      'rgba(229,115,63,1)',
                      'rgba(240,189,108,1)',
                      'rgba(237,214,102,1)',
                      'rgba(77,168,222,1)',
                      'rgba(25,168,164,1)',
                    ],
                    chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                  },
                },
                ChartsData: {
                  lable: '数据接入',
                  propertyComponentName: 'ChartsDataConfigor',
                  value: {
                    currenEntry: 'staticData',
                    apiData: {
                      apiUrl:
                        'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                      apiResponseQuery: 'data.forecasts',
                      isUseFilter: true,
                      apiFilter:
                        "\n          // 可以使用data访问api请求的响应结果        \nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                      isUseInterval: true,
                      apiInterval: 10,
                    },
                    staticData: {
                      seriesList: ['元'],
                      source: [
                        {
                          s: '元',
                          y: '122',
                          x: '今日售票额',
                        },
                        {
                          s: '元',
                          y: '67',
                          x: '本周售票额',
                        },
                        {
                          s: '元',
                          y: '55',
                          x: '本月售票额',
                        },
                      ],
                    },
                  },
                },
                posSize: {
                  lable: '位置尺寸',
                  propertyComponentName: 'ChartsPosSizeConfiger',
                  value: {
                    width: 323,
                    height: 130,
                    left: 19,
                    top: 298,
                  },
                },
                fontStyle: {
                  lable: '图表文字样式',
                  propertyComponentName: 'ChartsFontStyleConfiger',
                  value: {
                    titleSize: 16,
                    titleColor: '#ccc',
                    xAxisSize: 12,
                    xAxisColor: '#c3dbff',
                    yAxisSize: 12,
                    yAxisColor: '#c3dbff',
                  },
                },
                chartsGrid: {
                  lable: '图表定位',
                  propertyComponentName: 'ChartsGridConfiger',
                  value: {
                    left: '5%',
                    right: '10%',
                    bottom: '0%',
                    top: '0%',
                  },
                },
                showStatus: {
                  value: 'norm',
                },
                chartsOpicity: {
                  propertyComponentName: 'ChartsOpicityConfiger',
                  value: 1,
                },
                chartsAnimation: {
                  propertyComponentName: 'ChartsAnimationConfiger',
                  value: {
                    isUseAnimation: false,
                    isUseStaticRefresh: false,
                    staticRefreshIntervalTime: 5,
                  },
                },
              },
            },
          ],
        },
        Background: {
          componentTitle: '视频背景',
          componentName: 'VideoBackground',
          componentOverViewImg: './img/backgrounds/VideoBackground.png',
          propertyData: {
            backgroundVideo: {
              propertyComponentName: 'VideosUploader',
              value: '#',
              lable: '视频路径',
            },
          },
        },
        Style: {
          componentTitle: '风格2',
          componentName: 'V2Style',
          componentOverViewImg: './img/styles/style2.png',
          propertyData: {
            cityName: {
              propertyComponentName: 'SingleInputor',
              value: '杭州',
              lable: '定位城市',
            },
            headerBackgroundColor: {
              propertyComponentName: 'SingleColorSelector',
              value: 'rgba(0, 0, 0, 0.6)',
              lable: '头部背景颜色',
            },
            menuStyle: {
              value: {
                height: 85,
                width: 1080,
              },
            },
          },
        },
        SceneryList: [
          {
            id: 'XIicMax-jH5q99YP_jgdd',
            IconPath: '/img/styles/menusIcons/menuIcon1.png',
            OverViewImg: './img/scene/scene.png',
            SceneName: '大屏展示',
            Background: {},
            Style: {},
            Charts: [
              {
                componentTitle: '环形图4',
                componentName: 'Pie5Charts',
                componentOverViewImg: './img/charts/PieCharts/Pie5Charts.png',
                id: 'Xsgxd_-B0ndhrpuGWXsG2',
                style: {
                  width: 237.848484848485,
                  height: 142.4242424242424,
                  left: 683.3396464646465,
                  top: 322.2348484848485,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '旅游产品路线统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['人数'],
                        source: [
                          {
                            s: '人数',
                            y: '122',
                            x: '2021-06-02 12:10:51',
                          },
                          {
                            s: '人数',
                            y: '67',
                            x: '2021-06-02 11:10:51',
                          },
                          {
                            s: '人数',
                            y: '55',
                            x: '2021-06-02 09:10:51',
                          },
                          {
                            s: '人数',
                            y: '34',
                            x: '2021-06-02 08:10:51',
                          },
                          {
                            s: '人数',
                            y: '12',
                            x: '2021-06-02 07:10:51',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 339.06060606060623,
                      height: 203.03030303030297,
                      left: 974.1224747474747,
                      top: 459.3560606060606,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: 'rgba(255, 62, 168, 1)',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '10%',
                      bottom: '5%',
                      top: '5%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: true,
                      isUseStaticRefresh: true,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '条形图5',
                componentName: 'Bar5Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar5Charts.png',
                id: 'LB5wHKNt4Smla5AutDCV6',
                style: {
                  width: 210.78787878787884,
                  height: 142.4242424242424,
                  left: 676.0997474747475,
                  top: 41.77777777777778,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '餐饮美食统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  chartsSubTitle: {
                    value: '',
                    lable: '图表内部标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  chartsSubTitleColor: {
                    value: '#fff',
                    lable: '图表内部标题颜色',
                    propertyComponentName: 'SingleColorSelector',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts2Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'apiData',
                      apiData: {
                        apiUrl:
                          'http://bdds.likezou.com/gthmmc/index.php?m=bdds&c=dataMange&a=activeStatisticsdata&directory_code=restaurant&destination_id=600&group=type',
                        apiResponseQuery: 'data.data.list',
                        isUseFilter: true,
                        apiFilter:
                          'dataSet.seriesList=["美食"];\r\ndataSet.source=[];\r\ndata.forEach((item)=>{\r\n  dataSet.source.push({\r\n      s:"美食",\r\n      y:item.countNums,\r\n      x:item?.type==1 ?"小吃烧烤":item?.type==2 ?"江湖海鲜":item?.type==3 ?"农家私房":item?.type==4 ?"西餐日料":item?.type==5 ?"火锅":"其它"\r\n  });\r\n})',
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['人数'],
                        source: [
                          {
                            s: '人数',
                            y: '5000',
                            x: '面包饮品',
                          },
                          {
                            s: '人数',
                            y: '2600',
                            x: '特色湘菜',
                          },
                          {
                            s: '人数',
                            y: '1300',
                            x: '小吃烤肉',
                          },
                          {
                            s: '人数',
                            y: '1300',
                            x: '江湖海鲜',
                          },
                          {
                            s: '人数',
                            y: '1250',
                            x: '农家私房',
                          },
                          {
                            s: '人数',
                            y: '1500',
                            x: '西餐日料',
                          },
                          {
                            s: '人数',
                            y: '1300',
                            x: '火锅',
                          },
                          {
                            s: '人数',
                            y: '1000',
                            x: '其他',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 300.4848484848486,
                      height: 203.03030303030297,
                      left: 963.8017676767677,
                      top: 59.55555555555555,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: 'rgba(71, 227, 196, 1)',
                      xAxisSize: '16',
                      xAxisColor: 'rgba(255, 255, 255, 1)',
                      yAxisSize: '16',
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      top: '35%',
                      right: '3%',
                      left: '5%',
                      bottom: '2%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: true,
                      isUseStaticRefresh: true,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '环形图3',
                componentName: 'Pie4Charts',
                componentOverViewImg: './img/charts/PieCharts/Pie4Charts.png',
                id: 'iMK9casAAKNTVgNFH8PL2',
                style: {
                  width: 226.00000000000006,
                  height: 170.00000000000006,
                  left: 13.361111111111112,
                  top: 281.3472222222223,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '景区景点统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'apiData',
                      apiData: {
                        apiUrl:
                          'http://bdds.likezou.com/gthmmc/index.php?m=bdds&c=dataMange&a=activeStatisticsdata&directory_code=play&destination_id=600&group=type',
                        apiResponseQuery: 'data.data.list',
                        isUseFilter: true,
                        apiFilter:
                          'dataSet.seriesList=["景区景点"];\r\ndataSet.source=[];\r\ndata.forEach((item)=>{\r\n  dataSet.source.push({\r\n      s:"景区景点",\r\n      y:item.countNums,\r\n      x:item?.type==1 ?"庙宇":item?.type==2 ?"特色建筑":item?.type==3 ?"自然风光":item?.type==4 ?"楼阁":item?.type==9 ?"楼台":"其它"\r\n  });\r\n})',
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['个'],
                        source: [
                          {
                            s: '个',
                            y: '122',
                            x: '乡村',
                          },
                          {
                            s: '个',
                            y: '67',
                            x: '城市',
                          },
                          {
                            s: '个',
                            y: '55',
                            x: '森林',
                          },
                          {
                            s: '个',
                            y: '34',
                            x: '湖泊',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 226.00000000000006,
                      height: 170.00000000000006,
                      left: 13.361111111111114,
                      top: 281.3472222222223,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: 'rgba(78, 255, 214, 1)',
                      xAxisSize: 12,
                      xAxisColor: 'rgba(255, 255, 255, 1)',
                      yAxisSize: '14',
                      yAxisColor: 'rgba(229, 235, 244, 1)',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '10%',
                      bottom: '5%',
                      top: '10%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: true,
                      isUseStaticRefresh: true,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '条形图7',
                componentName: 'Bar7Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar7Charts.png',
                id: 'INKWRTPRXTQdr3TX0Jz-_',
                style: {
                  width: 206.23880597014926,
                  height: 150.11940298507463,
                  left: 458.61048922056403,
                  top: 300.03207824513805,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '购物消费统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'apiData',
                      apiData: {
                        apiUrl:
                          'http://bdds.likezou.com/gthmmc/index.php?m=bdds&c=dataMange&a=activeStatisticsdata&directory_code=shop&destination_id=600&group=type',
                        apiResponseQuery: 'data.data.list',
                        isUseFilter: true,
                        apiFilter:
                          'dataSet.seriesList=["消费购物"];\r\ndataSet.source=[];\r\ndata.forEach((item)=>{\r\n  dataSet.source.push({\r\n      s:"消费购物",\r\n      y:item.countNums,\r\n      x:item?.type==1 ?"特色产品":item?.type==2 ?"古玩字画":item?.type==3 ?"超市":item?.type==4 ?"植物花店":"其它"\r\n  });\r\n})',
                        isUseInterval: false,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['数量'],
                        source: [
                          {
                            s: '数量',
                            y: '122',
                            x: '超市便利店',
                          },
                          {
                            s: '数量',
                            y: '67',
                            x: '植物花卉',
                          },
                          {
                            s: '数量',
                            y: '55',
                            x: '特色产品',
                          },
                          {
                            s: '数量',
                            y: '34',
                            x: '古玩字画',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 206.23880597014926,
                      height: 150.11940298507463,
                      left: 458.61048922056403,
                      top: 300.03207824513805,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: 'rgba(22, 96, 255, 1)',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      top: '10%',
                      right: '3%',
                      left: '-8%',
                      bottom: '2%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: true,
                      isUseStaticRefresh: true,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '条形图6',
                componentName: 'Bar6Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar6Charts.png',
                id: 'hiZBlKHY42ItTYz1zmYT1',
                style: {
                  width: 201.32835820895525,
                  height: 149.4179104477612,
                  left: 243.18319387908943,
                  top: 301.8685361073421,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '休闲娱乐统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  chartsSubTitle: {
                    value: '',
                    lable: '图表内部标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  chartsSubTitleColor: {
                    value: '#fff',
                    lable: '图表内部标题颜色',
                    propertyComponentName: 'SingleColorSelector',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'apiData',
                      apiData: {
                        apiUrl:
                          'http://bdds.likezou.com/gthmmc/index.php?m=bdds&c=dataMange&a=activeStatisticsdata&directory_code=shop&destination_id=600&group=type',
                        apiResponseQuery: 'data.data.list',
                        isUseFilter: true,
                        apiFilter:
                          'dataSet.seriesList=["消费购物"];\r\ndataSet.source=[];\r\ndata.forEach((item)=>{\r\n  dataSet.source.push({\r\n      s:"消费购物",\r\n      y:item.countNums,\r\n      x:item?.type==1 ?"特色产品":item?.type==2 ?"古玩字画":item?.type==3 ?"超市":item?.type==4 ?"植物花店":"其它"\r\n  });\r\n})',
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['人数'],
                        source: [
                          {
                            s: '人数',
                            y: '5000',
                            x: '亲子游乐',
                          },
                          {
                            s: '人数',
                            y: '2600',
                            x: '美容美发',
                          },
                          {
                            s: '人数',
                            y: '1300',
                            x: '文化展演',
                          },
                          {
                            s: '人数',
                            y: '1250',
                            x: '酒吧轰趴',
                          },
                          {
                            s: '人数',
                            y: '1250',
                            x: '康乐健身',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 201.32835820895525,
                      height: 149.4179104477612,
                      left: 243.18319387908943,
                      top: 301.8685361073421,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: 'rgba(178, 244, 80, 1)',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '10%',
                      bottom: '5%',
                      top: '5%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: true,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '饼状图1',
                componentName: 'Pie1Charts',
                componentOverViewImg: './img/charts/PieCharts/Pie1Charts.png',
                id: '4ijdo2GEhEUm8J0_MBo2b',
                style: {
                  width: 225.0303030303031,
                  height: 196.5454545454546,
                  left: 1.6020715630885192,
                  top: 50.21078154425613,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '旅游酒店统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: ['#FF8700', '#ffc300', '#00e473', '#009DFF', '#0034ff'],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'apiData',
                      apiData: {
                        apiUrl:
                          'http://bdds.likezou.com/gthmmc/index.php?m=bdds&c=dataMange&a=activeStatisticsdata&directory_code=stay&destination_id=600&group=type',
                        apiResponseQuery: 'data.data.list',
                        isUseFilter: true,
                        apiFilter:
                          'dataSet.seriesList=["人"];\r\ndataSet.source=[];\r\ndata.forEach((item)=>{\r\n  dataSet.source.push({\r\n      s:"人",\r\n      y:item.countNums,\r\n      x:item?.type==1 ?"精品酒店":item?.type==2 ?"快捷连锁":item?.type==3 ?"民宿客栈":item?.type==4 ?"酒店公寓":"其它"\r\n  });\r\n})',
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['家'],
                        source: [
                          {
                            x: '文化特色主题酒店',
                            y: '123',
                            s: '家',
                          },
                          {
                            x: '低碳环保酒店',
                            y: '121',
                            s: '家',
                          },
                          {
                            x: '舒适型酒店',
                            y: '120',
                            s: '家',
                          },
                          {
                            x: '中档住宿酒店',
                            y: '211',
                            s: '家',
                          },
                          {
                            x: '家庭型住宿酒店',
                            y: '21',
                            s: '家',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 225.0303030303031,
                      height: 196.5454545454546,
                      left: 1.6020715630885192,
                      top: 50.21078154425613,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: 'rgba(9, 145, 255, 1)',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      top: '17%',
                      bottom: '57%',
                      left: '40%',
                      right: '45%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: true,
                      isUseStaticRefresh: true,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '地图',
                componentName: 'Earth1Charts',
                componentOverViewImg: './img/charts/EarthCharts/Earth1Charts.png',
                id: 'kljLyzZNPd42PGO6AYRpi',
                style: {
                  width: 439.13432835820896,
                  height: 220.26865671641792,
                  left: 224.47761194029852,
                  top: 92.51111787998781,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '省份归属地统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts0Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['人数'],
                        source: [
                          {
                            s: '人数',
                            y: '122',
                            x: '2021-06-02 12:10:51',
                          },
                          {
                            s: '人数',
                            y: '67',
                            x: '2021-06-02 11:10:51',
                          },
                          {
                            s: '人数',
                            y: '55',
                            x: '2021-06-02 09:10:51',
                          },
                          {
                            s: '人数',
                            y: '34',
                            x: '2021-06-02 08:10:51',
                          },
                          {
                            s: '人数',
                            y: '12',
                            x: '2021-06-02 07:10:51',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 439.13432835820896,
                      height: 220.26865671641792,
                      left: 224.47761194029852,
                      top: 92.51111787998781,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '75%',
                      right: '3%',
                      bottom: '10%',
                      top: '5%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: true,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '翻牌器',
                componentName: 'Others2Charts',
                componentOverViewImg: './img/charts/OthersCharts/Others2Charts.png',
                id: 'Vxvfhhpb5p3qx50fF4pvu',
                style: {
                  width: 403.843081887858,
                  height: 86.67204517950786,
                  left: 265.13432835820896,
                  top: 36.12686567164179,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '景区实时人数',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  scaleratio: {
                    value: '1.8',
                    lable: '组件缩放倍数',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts0Border',
                    },
                  },
                  chartsColor: {
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'http://bdds.likezou.com/gthmmc/index.php?m=bdds&c=dataMange&a=activeStatisticsdata&directory_code=shop&destination_id=600&group=type',
                        apiResponseQuery: 'data.data.list',
                        isUseFilter: true,
                        apiFilter:
                          'dataSet.seriesList=["消费购物"];\r\ndataSet.source=[];\r\ndata.forEach((item)=>{\r\n  dataSet.source.push({\r\n      s:"消费购物",\r\n      y:item.countNums,\r\n      x:item?.type==1 ?"特色产品":item?.type==2 ?"古玩字画":item?.type==3 ?"超市":item?.type==4 ?"植物花店":"其它"\r\n  });\r\n})',
                        isUseInterval: false,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['人数'],
                        source: [
                          {
                            s: '人数',
                            y: '122',
                            x: '2021-06-02',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 403.843081887858,
                      height: 86.67204517950786,
                      left: 265.13432835820896,
                      top: 36.12686567164179,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    value: {
                      left: '5%',
                      right: '10%',
                      bottom: '0%',
                      top: '0%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: true,
                      isUseStaticRefresh: true,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '环形图5',
                componentName: 'Pie6Charts',
                componentOverViewImg: './img/charts/PieCharts/Pie6Charts.png',
                id: 'rihHYoo20Yex8iMK1oYxz',
                style: {
                  width: 222.46666666666678,
                  height: 135.77777777777774,
                  left: 671.3285353535355,
                  top: 189.7209595959595,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '从业人员统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(114, 200, 106, 1)',
                        'rgba(229,115,63,1)',
                        'rgba(85, 221, 225, 1)',
                        'rgba(32, 111, 222, 1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['人'],
                        source: [
                          {
                            s: '人',
                            x: '导游',
                            y: 16,
                          },
                          {
                            s: '人',
                            x: '票务员',
                            y: 27,
                          },
                          {
                            s: '人',
                            x: '咨询员',
                            y: 54,
                          },
                          {
                            s: '人',
                            x: '营销员',
                            y: 92,
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 222.46666666666678,
                      height: 135.77777777777774,
                      left: 671.3285353535355,
                      top: 189.7209595959595,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: 'rgba(255, 170, 33, 1)',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    value: {
                      left: '5%',
                      right: '10%',
                      bottom: '5%',
                      top: '5%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: true,
                      isUseStaticRefresh: true,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
            ],
          },
          {
            id: 'qc-eiI_xzSNWiPuHAyF9O',
            IconPath: '/img/styles/menusIcons/menuIcon2.png',
            OverViewImg: './img/scene/scene.png',
            SceneName: '实时数据',
            Background: {},
            Style: {},
            Charts: [
              {
                componentTitle: '环形图2',
                componentName: 'Pie3Charts',
                componentOverViewImg: './img/charts/PieCharts/Pie3Charts.png',
                id: 'nscrysDC_xBU2MZQ_CqjJ',
                style: {
                  width: 201.70833333333337,
                  height: 178.8611111111112,
                  left: 45.69444444444443,
                  top: 55.48611111111111,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '游客性别统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        '#fb1943',
                        '#3de4b5',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['人数'],
                        source: [
                          {
                            s: '人数',
                            y: '12111',
                            x: '男性',
                          },
                          {
                            s: '人数',
                            y: '6711',
                            x: '女性',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 283.25,
                      height: 251.16666666666666,
                      left: 64.16666666666666,
                      top: 77.91666666666666,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: 'rgba(255, 156, 64, 1)',
                      xAxisSize: 20,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 20,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: true,
                      isUseStaticRefresh: true,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '条形图3',
                componentName: 'Bar3Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar3Charts.png',
                id: '319by2a33X6-9925qjYCx',
                style: {
                  width: 235.00000000000006,
                  height: 162.54166666666674,
                  left: 25.458333333333332,
                  top: 279.3888888888889,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '游客年龄统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(254, 128, 205, 1)',
                        'rgba(30, 252, 122, 1)',
                        'rgba(63, 210, 239, 1)',
                        'rgba(34, 46, 57, 0.39)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['杭州市'],
                        source: [
                          {
                            s: '杭州市',
                            x: '2021-05-21',
                            y: '25',
                          },
                          {
                            s: '杭州市',
                            x: '2021-05-22',
                            y: '26',
                          },
                          {
                            s: '杭州市',
                            x: '2021-05-23',
                            y: '20',
                          },
                          {
                            s: '杭州市',
                            x: '2021-05-24',
                            y: '27',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 330,
                      height: 228.25,
                      left: 35.75,
                      top: 392.3333333333333,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: 'rgba(101, 255, 234, 1)',
                      xAxisSize: '16',
                      xAxisColor: '#c3dbff',
                      yAxisSize: '16',
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '5%',
                      bottom: '5%',
                      top: '12%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: true,
                      isUseStaticRefresh: true,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '条形图4',
                componentName: 'Bar4Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar4Charts.png',
                id: 'R4XqDGo5jagYDhdV5L6iO',
                style: {
                  width: 327.69444444444457,
                  height: 100.5277777777778,
                  left: 282.00000000000006,
                  top: 336.18055555555566,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '游客驻留时长统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        '#2ae0fc',
                        '#f7ce04',
                        '#49d673',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['人数'],
                        source: [
                          {
                            x: '1-2小时',
                            y: 25,
                            s: '人数',
                          },
                          {
                            x: '3-4小时',
                            y: 19,
                            s: '人数',
                          },
                          {
                            x: '5小时以上',
                            y: 18,
                            s: '人数',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 460.16666666666663,
                      height: 141.16666666666666,
                      left: 396,
                      top: 472.0833333333333,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: 'rgba(255, 203, 46, 1)',
                      xAxisSize: '16',
                      xAxisColor: '#c3dbff',
                      yAxisSize: '16',
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '-2%',
                      top: '0%',
                      bottom: '35%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: true,
                      isUseStaticRefresh: true,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '条形图2',
                componentName: 'Bar2Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar2Charts.png',
                id: 'K6kP6tMYyzqcWaqyMKoHN',
                style: {
                  width: 244.25757575757578,
                  height: 150.25757575757578,
                  left: 639.0694444444447,
                  top: 290.96085858585855,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '游客时段人数统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果        \nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['人数'],
                        source: [
                          {
                            s: '人数',
                            y: '122',
                            x: '2021-06-02 12:10:51',
                          },
                          {
                            s: '人数',
                            y: '67',
                            x: '2021-06-02 11:10:51',
                          },
                          {
                            s: '人数',
                            y: '55',
                            x: '2021-06-02 09:10:51',
                          },
                          {
                            s: '人数',
                            y: '34',
                            x: '2021-06-02 08:10:51',
                          },
                          {
                            s: '人数',
                            y: '12',
                            x: '2021-06-02 07:10:51',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 343,
                      height: 211,
                      left: 897.4166666666666,
                      top: 408.5833333333333,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: 'rgba(78, 245, 228, 1)',
                      xAxisSize: '16',
                      xAxisColor: '#c3dbff',
                      yAxisSize: '16',
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '10%',
                      bottom: '5%',
                      top: '5%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: true,
                      isUseStaticRefresh: true,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '饼状图1',
                componentName: 'Pie1Charts',
                componentOverViewImg: './img/charts/PieCharts/Pie1Charts.png',
                id: 'DeAq5rUYqezdQdsJ2Tuzb',
                style: {
                  width: 219.98611111111123,
                  height: 204.97222222222217,
                  left: 652.7777777777777,
                  top: 61.36111111111111,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '游客来源统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: ['#FF8700', '#ffc300', '#00e473', '#009DFF', '#0034ff'],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['人'],
                        source: [
                          {
                            x: '浙江',
                            y: 40083,
                            s: '人',
                          },
                          {
                            x: '湖南',
                            y: 33974,
                            s: '人',
                          },
                          {
                            x: '陕西',
                            y: 15400,
                            s: '人',
                          },
                          {
                            x: '北京',
                            y: 11021,
                            s: '人',
                          },
                          {
                            x: '上海',
                            y: 30696,
                            s: '人',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 308.91666666666663,
                      height: 287.8333333333333,
                      left: 916.6666666666666,
                      top: 86.16666666666666,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: 'rgba(34, 151, 224, 1)',
                      xAxisSize: '16',
                      xAxisColor: '#c3dbff',
                      yAxisSize: '16',
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      top: '17%',
                      bottom: '57%',
                      left: '40%',
                      right: '45%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: true,
                      isUseStaticRefresh: true,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '地图',
                componentName: 'Earth1Charts',
                componentOverViewImg: './img/charts/EarthCharts/Earth1Charts.png',
                id: 'XNfifTaR9-iqTd1OLXgt6',
                style: {
                  width: 354.4583333333335,
                  height: 267.6388888888889,
                  left: 277.4305555555556,
                  top: 48.30555555555554,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '地图',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts0Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['人数'],
                        source: [
                          {
                            s: '人数',
                            y: '122',
                            x: '2021-06-02 12:10:51',
                          },
                          {
                            s: '人数',
                            y: '67',
                            x: '2021-06-02 11:10:51',
                          },
                          {
                            s: '人数',
                            y: '55',
                            x: '2021-06-02 09:10:51',
                          },
                          {
                            s: '人数',
                            y: '34',
                            x: '2021-06-02 08:10:51',
                          },
                          {
                            s: '人数',
                            y: '12',
                            x: '2021-06-02 07:10:51',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 497.75,
                      height: 375.8333333333333,
                      left: 389.5833333333333,
                      top: 67.83333333333333,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: '16',
                      xAxisColor: '#c3dbff',
                      yAxisSize: '16',
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '80%',
                      right: '8%',
                      bottom: '10%',
                      top: '5%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
            ],
          },
          {
            id: 'G_eFNxHiq94UbsDl2EV8J',
            IconPath: '/img/styles/menusIcons/menuIcon3.png',
            OverViewImg: './img/scene/scene.png',
            SceneName: '票务数据',
            Background: {},
            Style: {},
            Charts: [
              {
                componentTitle: '柱状图1',
                componentName: 'Bar1Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar1Charts.png',
                id: '4Kaojz52ERFmV5_eemAXM',
                style: {
                  width: 511,
                  height: 214.99999999999997,
                  left: 354.90909090909105,
                  top: 236.54545454545456,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '景区预约量按统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(26, 159, 110, 1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果        \nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['预约量'],
                        source: [
                          {
                            s: '预约量',
                            x: '2021-05-21',
                            y: '25',
                          },
                          {
                            s: '预约量',
                            x: '2021-05-22',
                            y: '26',
                          },
                          {
                            s: '预约量',
                            x: '2021-05-23',
                            y: '20',
                          },
                          {
                            s: '预约量',
                            x: '2021-05-24',
                            y: '27',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 511,
                      height: 215,
                      left: 354.90909090909105,
                      top: 236.5454545454546,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '5%',
                      bottom: '5%',
                      top: '12%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 3,
                    },
                  },
                },
              },
              {
                componentTitle: '柱状图1',
                componentName: 'Bar1Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar1Charts.png',
                id: 'F2AWsCG5Lj0uqbRKDSb0J',
                style: {
                  width: 544.0606060606063,
                  height: 206.84848484848487,
                  left: 342.83549783549796,
                  top: 39.268398268398265,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '景区预约量按月统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果        \nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['预约量'],
                        source: [
                          {
                            s: '预约量',
                            x: '一月',
                            y: '251',
                          },
                          {
                            s: '预约量',
                            x: '二月',
                            y: '236',
                          },
                          {
                            s: '预约量',
                            x: '三月',
                            y: '220',
                          },
                          {
                            s: '预约量',
                            x: '四月',
                            y: '227',
                          },
                          {
                            s: '预约量',
                            y: '234',
                            x: '五月',
                          },
                          {
                            s: '预约量',
                            y: '234',
                            x: '六月',
                          },
                          {
                            s: '预约量',
                            y: '554',
                            x: '七月',
                          },
                          {
                            s: '预约量',
                            y: '333',
                            x: '八月',
                          },
                          {
                            s: '预约量',
                            y: '643',
                            x: '九月',
                          },
                          {
                            s: '预约量',
                            y: '336',
                            x: '十月',
                          },
                          {
                            s: '预约量',
                            y: '226',
                            x: '十一月',
                          },
                          {
                            s: '预约量',
                            y: '222',
                            x: '十二月',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 544.0606060606063,
                      height: 206.84848484848487,
                      left: 342.83549783549796,
                      top: 39.268398268398265,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '5%',
                      bottom: '5%',
                      top: '12%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 3,
                    },
                  },
                },
              },
              {
                componentTitle: '柱状图3',
                componentName: 'Bar3Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar3Charts.png',
                id: 'u8eoVRDtppTf9XsbsgwLW',
                style: {
                  width: 324.23995052566494,
                  height: 233.8775510204082,
                  left: 10.224489795918373,
                  top: 41.24489795918369,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '景区预约按年统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(254, 128, 205, 1)',
                        'rgba(30, 252, 122, 1)',
                        'rgba(63, 210, 239, 1)',
                        'rgba(34, 46, 57, 0.39)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['预约量'],
                        source: [
                          {
                            s: '预约量',
                            x: '2021',
                            y: '22345',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 324.23995052566494,
                      height: 233.8775510204082,
                      left: 10.224489795918373,
                      top: 41.24489795918369,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '5%',
                      bottom: '5%',
                      top: '12%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '文字1',
                componentName: 'Others3Charts',
                componentOverViewImg: './img/charts/OthersCharts/Others3Charts.png',
                id: 'Ja0g5-GLIT-kwas3XXgyw',
                style: {
                  width: 323,
                  height: 130,
                  left: 19,
                  top: 298,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '图表标题',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  scaleratio: {
                    value: '2',
                    lable: '组件缩放倍数',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts0Border',
                    },
                  },
                  chartsColor: {
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果        \nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['元'],
                        source: [
                          {
                            s: '元',
                            y: '122',
                            x: '今日售票额',
                          },
                          {
                            s: '元',
                            y: '67',
                            x: '本周售票额',
                          },
                          {
                            s: '元',
                            y: '55',
                            x: '本月售票额',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 323,
                      height: 130,
                      left: 19,
                      top: 298,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '10%',
                      bottom: '0%',
                      top: '0%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
            ],
          },
          {
            id: '9lNY3PknZVypBlVlluQBP',
            IconPath: '/img/styles/menusIcons/menuIcon8.png',
            OverViewImg: './img/scene/scene.png',
            SceneName: '停车数据',
            Background: {},
            Style: {},
            Charts: [
              {
                componentTitle: '柱状图3',
                componentName: 'Bar3Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar3Charts.png',
                id: 'mU99AjD22RXzIGoB5mbeE',
                style: {
                  width: 300,
                  height: 208,
                  left: 605,
                  top: 244.99999999999997,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '停车场收费按年统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(254, 128, 205, 1)',
                        'rgba(30, 252, 122, 1)',
                        'rgba(63, 210, 239, 1)',
                        'rgba(34, 46, 57, 0.39)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['按年统计'],
                        source: [
                          {
                            s: '按年统计',
                            x: '2020',
                            y: '25',
                          },
                          {
                            s: '按年统计',
                            x: '2021',
                            y: '26',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 300,
                      height: 208,
                      left: 605,
                      top: 245,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '5%',
                      bottom: '5%',
                      top: '12%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '环形图3',
                componentName: 'Pie4Charts',
                componentOverViewImg: './img/charts/PieCharts/Pie4Charts.png',
                id: 'fiCjXitrH6OmzERNIOkDg',
                style: {
                  width: 261,
                  height: 199,
                  left: 10.223880597014926,
                  top: 49.8955223880597,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '车位数据',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['数量'],
                        source: [
                          {
                            s: '数量',
                            y: '122',
                            x: '已停车位',
                          },
                          {
                            s: '数量',
                            y: '67',
                            x: '剩余车位',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 261,
                      height: 199,
                      left: 10.223880597014926,
                      top: 49.8955223880597,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '10%',
                      bottom: '5%',
                      top: '5%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '柱状图6',
                componentName: 'Bar6Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar6Charts.png',
                id: 'ij1MfNL_YNkMPx9uXi-yQ',
                style: {
                  width: 282,
                  height: 198,
                  left: 10,
                  top: 247,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '景区车辆城市归属地统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  chartsSubTitle: {
                    value: '归属地统计',
                    lable: '图表内部标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  chartsSubTitleColor: {
                    value: '#fff',
                    lable: '图表内部标题颜色',
                    propertyComponentName: 'SingleColorSelector',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['人数'],
                        source: [
                          {
                            s: '人数',
                            y: '5000',
                            x: '重庆',
                          },
                          {
                            s: '人数',
                            y: '2600',
                            x: '四川',
                          },
                          {
                            s: '人数',
                            y: '1300',
                            x: '贵州',
                          },
                          {
                            s: '人数',
                            y: '1250',
                            x: '河南',
                          },
                          {
                            s: '人数',
                            y: '1250',
                            x: '湖北',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 282,
                      height: 198,
                      left: 10,
                      top: 247,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '10%',
                      bottom: '5%',
                      top: '5%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '柱状图1',
                componentName: 'Bar1Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar1Charts.png',
                id: 'VjzmgxaSJ5ANqP7j_LmDj',
                style: {
                  width: 300,
                  height: 203.99999999999997,
                  left: 292,
                  top: 243.99999999999997,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '景区停车场收费按日统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(254, 128, 205, 1)',
                        'rgba(30, 252, 122, 1)',
                        'rgba(63, 210, 239, 1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(255, 255, 255, 0)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果        \nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['按日统计'],
                        source: [
                          {
                            s: '按日统计',
                            x: '2021-05-21',
                            y: '25',
                          },
                          {
                            s: '按日统计',
                            x: '2021-05-22',
                            y: '26',
                          },
                          {
                            s: '按日统计',
                            x: '2021-05-23',
                            y: '20',
                          },
                          {
                            s: '按日统计',
                            x: '2021-05-24',
                            y: '27',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 300,
                      height: 204,
                      left: 292,
                      top: 244,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '5%',
                      bottom: '5%',
                      top: '12%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 3,
                    },
                  },
                },
              },
              {
                componentTitle: '柱状图3',
                componentName: 'Bar3Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar3Charts.png',
                id: 'KThBuVzxiUdIQOYf42mhr',
                style: {
                  width: 300,
                  height: 186.99999999999997,
                  left: 603,
                  top: 47,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '景区车辆城市归属地统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(254, 128, 205, 1)',
                        'rgba(30, 252, 122, 1)',
                        'rgba(63, 210, 239, 1)',
                        'rgba(34, 46, 57, 0.39)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['归属地统计'],
                        source: [
                          {
                            s: '归属地统计',
                            x: '重庆',
                            y: '25',
                          },
                          {
                            s: '归属地统计',
                            x: '大同',
                            y: '26',
                          },
                          {
                            s: '归属地统计',
                            x: '北京',
                            y: '20',
                          },
                          {
                            s: '归属地统计',
                            x: '上海',
                            y: '27',
                          },
                          {
                            s: '归属地统计',
                            y: '43',
                            x: '太原',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 300,
                      height: 187,
                      left: 603,
                      top: 47,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '5%',
                      bottom: '5%',
                      top: '12%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '柱状图1',
                componentName: 'Bar1Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar1Charts.png',
                id: 'GxhCvQrZRWiK2SJFYGP5j',
                style: {
                  width: 331.99999999999994,
                  height: 184.99999999999997,
                  left: 275.14925373134326,
                  top: 50.597014925373124,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '停车场收费按月统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(62, 157, 191, 1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果        \nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['按月统计'],
                        source: [
                          {
                            s: '按月统计',
                            x: '一月',
                            y: '25',
                          },
                          {
                            s: '按月统计',
                            x: '二月',
                            y: '26',
                          },
                          {
                            s: '按月统计',
                            x: '三月',
                            y: '20',
                          },
                          {
                            s: '按月统计',
                            x: '四月',
                            y: '27',
                          },
                          {
                            s: '按月统计',
                            y: '23',
                            x: '五月',
                          },
                          {
                            s: '按月统计',
                            y: '011',
                            x: '六月',
                          },
                          {
                            s: '按月统计',
                            y: '22',
                            x: '七月',
                          },
                          {
                            s: '按月统计',
                            y: '1',
                            x: '八月',
                          },
                          {
                            s: '按月统计',
                            y: '3',
                            x: '九月',
                          },
                          {
                            s: '按月统计',
                            y: '44',
                            x: '十月',
                          },
                          {
                            s: '按月统计',
                            y: '044',
                            x: '十一月',
                          },
                          {
                            s: '按月统计',
                            y: '50',
                            x: '十二月',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 332,
                      height: 185,
                      left: 275.14925373134326,
                      top: 50.59701492537313,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: '12',
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '5%',
                      bottom: '5%',
                      top: '12%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 3,
                    },
                  },
                },
              },
            ],
          },
          {
            id: 'qoMbTmKHwyvtHx4f8bKAp',
            IconPath: '/img/styles/menusIcons/menuIcon4.png',
            OverViewImg: './img/scene/scene.png',
            SceneName: '游客画像',
            Background: {},
            Style: {},
            Charts: [
              {
                componentTitle: '环形图2',
                componentName: 'Pie3Charts',
                componentOverViewImg: './img/charts/PieCharts/Pie3Charts.png',
                id: '71NRhhgtjUb0RWzO_bnwm',
                style: {
                  width: 237,
                  height: 188,
                  left: 651,
                  top: 258,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '游客有车比例统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        '#fb1943',
                        '#3de4b5',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['人数'],
                        source: [
                          {
                            s: '人数',
                            y: '66%',
                            x: '有车比例',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 237,
                      height: 188,
                      left: 651,
                      top: 258,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 20,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 20,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '环形图4',
                componentName: 'Pie5Charts',
                componentOverViewImg: './img/charts/PieCharts/Pie5Charts.png',
                id: 'Gth9rRy-SsRlG-0oiZUp8',
                style: {
                  width: 330,
                  height: 203,
                  left: 325,
                  top: 259,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '游客消费水平统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['人数'],
                        source: [
                          {
                            s: '人数',
                            y: '122',
                            x: '大众',
                          },
                          {
                            s: '人数',
                            y: '67',
                            x: '奢侈',
                          },
                          {
                            s: '人数',
                            y: '55',
                            x: '创意',
                          },
                          {
                            s: '人数',
                            y: '23',
                            x: '潮流',
                          },
                          {
                            s: '人数',
                            y: '44',
                            x: '高端',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 334,
                      height: 198,
                      left: 325,
                      top: 259,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '10%',
                      bottom: '5%',
                      top: '5%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: true,
                      isUseStaticRefresh: true,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '柱状图3',
                componentName: 'Bar3Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar3Charts.png',
                id: 'Ux53wLZxGoe-Qby5QA0XQ',
                style: {
                  width: 300,
                  height: 192,
                  left: 10,
                  top: 259,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '游客年龄统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(254, 128, 205, 1)',
                        'rgba(30, 252, 122, 1)',
                        'rgba(63, 210, 239, 1)',
                        'rgba(34, 46, 57, 0.39)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['年龄统计'],
                        source: [
                          {
                            s: '年龄统计',
                            x: '0-15',
                            y: '25',
                          },
                          {
                            s: '年龄统计',
                            x: '16-25',
                            y: '26',
                          },
                          {
                            s: '年龄统计',
                            x: '26-35',
                            y: '120',
                          },
                          {
                            s: '年龄统计',
                            x: '36-45',
                            y: '127',
                          },
                          {
                            s: '年龄统计',
                            y: '10',
                            x: '大于46',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 300,
                      height: 192,
                      left: 10,
                      top: 259,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '5%',
                      bottom: '5%',
                      top: '12%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '折线图1',
                componentName: 'Line1Charts',
                componentOverViewImg: './img/charts/LineCharts/Line1Charts.png',
                id: 'vA1t3sBTgXb32JXnIXIYL',
                style: {
                  width: 300,
                  height: 196.99999999999997,
                  left: 320,
                  top: 48.99999999999999,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '游客省份归属地统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果        \nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['人数'],
                        source: [
                          {
                            s: '人数',
                            y: '122',
                            x: '重庆',
                          },
                          {
                            s: '人数',
                            y: '67',
                            x: '四川',
                          },
                          {
                            s: '人数',
                            y: '55',
                            x: '贵州',
                          },
                          {
                            s: '人数',
                            y: '34',
                            x: '湖南',
                          },
                          {
                            s: '人数',
                            y: '12',
                            x: '河北',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 300,
                      height: 197,
                      left: 320,
                      top: 49,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '10%',
                      bottom: '5%',
                      top: '5%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '柱状图3',
                componentName: 'Bar3Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar3Charts.png',
                id: 'dm8mdBEQzyStv7DOny77a',
                style: {
                  width: 275,
                  height: 199,
                  left: 619,
                  top: 48.99999999999999,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '游客城市归属地统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(254, 128, 205, 1)',
                        'rgba(30, 252, 122, 1)',
                        'rgba(63, 210, 239, 1)',
                        'rgba(34, 46, 57, 0.39)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['归属地统计'],
                        source: [
                          {
                            s: '归属地统计',
                            x: '重庆',
                            y: '25',
                          },
                          {
                            s: '归属地统计',
                            x: '成都',
                            y: '26',
                          },
                          {
                            s: '归属地统计',
                            x: '西安',
                            y: '20',
                          },
                          {
                            s: '归属地统计',
                            x: '山西',
                            y: '27',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 275,
                      height: 199,
                      left: 619,
                      top: 49,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '5%',
                      bottom: '5%',
                      top: '12%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '环形图3',
                componentName: 'Pie4Charts',
                componentOverViewImg: './img/charts/PieCharts/Pie4Charts.png',
                id: 'mUoHoV528-e7PiFxAHaxG',
                style: {
                  width: 300,
                  height: 199,
                  left: 13.999999999999998,
                  top: 53,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '游客性别统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['数量'],
                        source: [
                          {
                            s: '数量',
                            y: '122',
                            x: '男',
                          },
                          {
                            s: '数量',
                            y: '67',
                            x: '女',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 300,
                      height: 199,
                      left: 14,
                      top: 53,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '10%',
                      bottom: '5%',
                      top: '5%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
            ],
          },
          {
            id: 'LRySa1wo3QScvBYlOzvEy',
            IconPath: '/img/styles/menusIcons/menuIcon5.png',
            OverViewImg: './img/scene/scene.png',
            SceneName: '资源数据',
            Background: {},
            Style: {},
            Charts: [
              {
                componentTitle: '柱状图5',
                componentName: 'Bar5Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar5Charts.png',
                id: 'AoPnlWyRW2Mfaz1b3S4u4',
                style: {
                  width: 261.6756756756757,
                  height: 182.9189189189189,
                  left: 629.054054054054,
                  top: 52.62162162162162,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '休闲娱乐统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  chartsSubTitle: {
                    value: '美食',
                    lable: '图表内部标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  chartsSubTitleColor: {
                    value: '#fff',
                    lable: '图表内部标题颜色',
                    propertyComponentName: 'SingleColorSelector',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'apiData',
                      apiData: {
                        apiUrl:
                          'http://bdds.likezou.com/gthmmc/index.php?m=bdds&c=dataMange&a=activeStatisticsdata&directory_code=amuse&destination_id=600&group=type',
                        apiResponseQuery: 'data.data.list',
                        isUseFilter: true,
                        apiFilter:
                          'dataSet.seriesList=["休闲娱乐"];\r\ndataSet.source=[];\r\ndata.forEach((item)=>{\r\n  dataSet.source.push({\r\n      s:"休闲娱乐",\r\n      y:item.countNums,\r\n      x:item?.type==1 ?"酒吧ktv":item?.type==2 ?"茶馆":item?.type==3 ?"网吧咖啡":item?.type==4 ?"康乐健身":item?.type==5 ?"文化展演":"其它"\r\n  });\r\n})',
                        isUseInterval: false,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['人数'],
                        source: [
                          {
                            s: '人数',
                            y: '5000',
                            x: '面包饮品',
                          },
                          {
                            s: '人数',
                            y: '2600',
                            x: '特色湘菜',
                          },
                          {
                            s: '人数',
                            y: '1300',
                            x: '小吃烤肉',
                          },
                          {
                            s: '人数',
                            y: '1300',
                            x: '江湖海鲜',
                          },
                          {
                            s: '人数',
                            y: '1250',
                            x: '农家私房',
                          },
                          {
                            s: '人数',
                            y: '1500',
                            x: '西餐日料',
                          },
                          {
                            s: '人数',
                            y: '1300',
                            x: '火锅',
                          },
                          {
                            s: '人数',
                            y: '1000',
                            x: '其他',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 206,
                      height: 144,
                      left: 495.2127659574468,
                      top: 41.42553191489362,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      top: '35%',
                      right: '3%',
                      left: '5%',
                      bottom: '2%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '柱状图1',
                componentName: 'Bar1Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar1Charts.png',
                id: 'F5zLUgOiGBRbkCvLAOPBw',
                style: {
                  width: 320.10810810810807,
                  height: 208.32432432432432,
                  left: 311.7027027027027,
                  top: 50.54054054054054,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '旅游酒店统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'apiData',
                      apiData: {
                        apiUrl:
                          'http://bdds.likezou.com/gthmmc/index.php?m=bdds&c=dataMange&a=activeStatisticsdata&directory_code=stay&destination_id=600&group=type',
                        apiResponseQuery: 'data.data.list',
                        isUseFilter: true,
                        apiFilter:
                          'dataSet.seriesList=["酒店住宿"];\r\ndataSet.source=[];\r\ndata.forEach((item)=>{\r\n  dataSet.source.push({\r\n      s:"酒店住宿",\r\n      y:item.countNums,\r\n      x:item?.type==1 ?"精品酒店":item?.type==2 ? "快捷连锁":item?.type==3 ? "民宿客栈":item?.type==4 ? "酒店公寓":"其它"\r\n  });\r\n})',
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['杭州市', '太原市', '北京市'],
                        source: [
                          {
                            s: '杭州市',
                            x: '2021-05-21',
                            y: '25',
                          },
                          {
                            s: '杭州市',
                            x: '2021-05-22',
                            y: '26',
                          },
                          {
                            s: '杭州市',
                            x: '2021-05-23',
                            y: '20',
                          },
                          {
                            s: '杭州市',
                            x: '2021-05-24',
                            y: '27',
                          },
                          {
                            s: '太原市',
                            x: '2021-05-21',
                            y: '25',
                          },
                          {
                            s: '太原市',
                            x: '2021-05-22',
                            y: '26',
                          },
                          {
                            s: '太原市',
                            x: '2021-05-23',
                            y: '20',
                          },
                          {
                            s: '太原市',
                            x: '2021-05-24',
                            y: '27',
                          },
                          {
                            s: '北京市',
                            x: '2021-05-21',
                            y: '25',
                          },
                          {
                            s: '北京市',
                            x: '2021-05-22',
                            y: '26',
                          },
                          {
                            s: '北京市',
                            x: '2021-05-23',
                            y: '20',
                          },
                          {
                            s: '北京市',
                            x: '2021-05-24',
                            y: '27',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 252,
                      height: 164,
                      left: 245.38297872340428,
                      top: 39.787234042553195,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '5%',
                      bottom: '5%',
                      top: '12%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 3,
                    },
                  },
                },
              },
              {
                componentTitle: '环形图3',
                componentName: 'Pie4Charts',
                componentOverViewImg: './img/charts/PieCharts/Pie4Charts.png',
                id: 'fVnqExaVbJ5QXcD4IUwrW',
                style: {
                  width: 303.5945945945946,
                  height: 208.32432432432432,
                  left: 6.567567567567568,
                  top: 47.54054054054054,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '景区景点统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'apiData',
                      apiData: {
                        apiUrl:
                          'http://bdds.likezou.com/gthmmc/index.php?m=bdds&c=dataMange&a=activeStatisticsdata&directory_code=play&destination_id=600&group=type',
                        apiResponseQuery: 'data.data.list',
                        isUseFilter: true,
                        apiFilter:
                          'dataSet.seriesList=["景区景点"];\r\ndataSet.source=[];\r\ndata.forEach((item)=>{\r\n  dataSet.source.push({\r\n      s:"景区景点",\r\n      y:item.countNums,\r\n      x:item?.type==1 ?"庙宇":item?.type==2 ?"特色建筑":item?.type==3 ?"自然风光":item?.type==4 ?"楼阁":item?.type==9 ?"楼台":"其它"\r\n  });\r\n})',
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['数量'],
                        source: [
                          {
                            s: '数量',
                            y: '122',
                            x: '三元',
                          },
                          {
                            s: '数量',
                            y: '67',
                            x: '金福',
                          },
                          {
                            s: '数量',
                            y: '55',
                            x: '陇川',
                          },
                          {
                            s: '数量',
                            y: '34',
                            x: '乙级',
                          },
                          {
                            s: '数量',
                            y: '12',
                            x: '贵豪猪',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 239,
                      height: 164,
                      left: 5.170212765957448,
                      top: 37.42553191489362,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '10%',
                      bottom: '5%',
                      top: '5%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '柱状图7',
                componentName: 'Bar7Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar7Charts.png',
                id: '6ieDeRL77yMg_awkTnYul',
                style: {
                  width: 316.2972972972973,
                  height: 170.2162162162162,
                  left: 13.216216216216226,
                  top: 270.40540540540536,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '消费购物统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'apiData',
                      apiData: {
                        apiUrl:
                          'http://bdds.likezou.com/gthmmc/index.php?m=bdds&c=dataMange&a=activeStatisticsdata&directory_code=shop&destination_id=600&group=type',
                        apiResponseQuery: 'data.data.list',
                        isUseFilter: true,
                        apiFilter:
                          'dataSet.seriesList=["消费购物"];\r\ndataSet.source=[];\r\ndata.forEach((item)=>{\r\n  dataSet.source.push({\r\n      s:"消费购物",\r\n      y:item.countNums,\r\n      x:item?.type==1 ?"特色产品":item?.type==2 ?"古玩字画":item?.type==3 ?"超市":item?.type==4 ?"植物花店":"其它"\r\n  });\r\n})',
                        isUseInterval: false,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['数量'],
                        source: [
                          {
                            s: '数量',
                            y: '122',
                            x: '超市便利店',
                          },
                          {
                            s: '数量',
                            y: '67',
                            x: '植物花卉',
                          },
                          {
                            s: '数量',
                            y: '55',
                            x: '特色产品',
                          },
                          {
                            s: '数量',
                            y: '34',
                            x: '古玩字画',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 249,
                      height: 134,
                      left: 10.404255319148945,
                      top: 212.87234042553192,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      top: '10%',
                      right: '3%',
                      left: '-8%',
                      bottom: '2%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
              {
                componentTitle: '柱状图6',
                componentName: 'Bar6Charts',
                componentOverViewImg: './img/charts/BarCharts/Bar6Charts.png',
                id: 'LfDtRe6TQO0Jtu2YvKpFQ',
                style: {
                  width: 530.9729729729729,
                  height: 172.75675675675674,
                  left: 335.1081081081081,
                  top: 274.3243243243243,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '美食餐饮统计',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  chartsSubTitle: {
                    value: '',
                    lable: '图表内部标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  chartsSubTitleColor: {
                    value: '#fff',
                    lable: '图表内部标题颜色',
                    propertyComponentName: 'SingleColorSelector',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'apiData',
                      apiData: {
                        apiUrl:
                          'http://bdds.likezou.com/gthmmc/index.php?m=bdds&c=dataMange&a=activeStatisticsdata&directory_code=restaurant&destination_id=600&group=type',
                        apiResponseQuery: 'data.data.list',
                        isUseFilter: true,
                        apiFilter:
                          'dataSet.seriesList=["美食"];\r\ndataSet.source=[];\r\ndata.forEach((item)=>{\r\n  dataSet.source.push({\r\n      s:"美食",\r\n      y:item.countNums,\r\n      x:item?.type==1 ?"小吃烧烤":item?.type==2 ?"江湖海鲜":item?.type==3 ?"农家私房":item?.type==4 ?"西餐日料":item?.type==5 ?"火锅":"其它"\r\n  });\r\n})',
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['人数'],
                        source: [
                          {
                            s: '人数',
                            y: '5000',
                            x: '亲子游乐',
                          },
                          {
                            s: '人数',
                            y: '2600',
                            x: '美容美发',
                          },
                          {
                            s: '人数',
                            y: '1300',
                            x: '文化展演',
                          },
                          {
                            s: '人数',
                            y: '1250',
                            x: '酒吧轰趴',
                          },
                          {
                            s: '人数',
                            y: '1250',
                            x: '康乐健身',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 418,
                      height: 136,
                      left: 263.8085106382979,
                      top: 215.95744680851064,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '10%',
                      bottom: '5%',
                      top: '5%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 5,
                    },
                  },
                },
              },
            ],
          },
          {
            id: 'K0e0N1FEIFMIndsa6Ji2k',
            IconPath: '/img/styles/menusIcons/menuIcon6.png',
            OverViewImg: './img/scene/scene.png',
            SceneName: '智能监控',
            Background: {},
            Style: {},
            Charts: [
              {
                componentTitle: '折线图3',
                componentName: 'Line3Charts',
                componentOverViewImg: './img/charts/LineCharts/Line3Charts.png',
                id: 'QalPlt5QVn1HKLc4AtIyr',
                style: {
                  width: 300,
                  height: 150,
                  left: 69,
                  top: 252,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '图表标题',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['杭州市'],
                        source: [
                          {
                            s: '杭州市',
                            x: '2021-05-21',
                            y: '25',
                          },
                          {
                            s: '杭州市',
                            x: '2021-05-22',
                            y: '26',
                          },
                          {
                            s: '杭州市',
                            x: '2021-05-23',
                            y: '20',
                          },
                          {
                            s: '杭州市',
                            x: '2021-05-24',
                            y: '27',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 300,
                      height: 150,
                      left: 69,
                      top: 252,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '5%',
                      bottom: '17%',
                      top: '12%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 3,
                    },
                  },
                },
              },
              {
                componentTitle: '折线图2',
                componentName: 'Line2Charts',
                componentOverViewImg: './img/charts/LineCharts/Line2Charts.png',
                id: 'kk2JkjcEmszSosD5Prhv4',
                style: {
                  width: 300,
                  height: 150,
                  left: 72,
                  top: 83,
                },
                isScaling: false,
                isMoving: false,
                propertyData: {
                  titleText: {
                    value: '图表标题',
                    lable: '图表标题',
                    propertyComponentName: 'SingleInputor',
                  },
                  borderConfig: {
                    propertyComponentName: 'ChartsBorderConfiger',
                    value: {
                      borderComponentName: 'Charts1Border',
                    },
                  },
                  chartsColor: {
                    propertyComponentName: 'ArrayColorSelector',
                    value: {
                      chartColor: [
                        'rgba(223,65,56,1)',
                        'rgba(229,115,63,1)',
                        'rgba(240,189,108,1)',
                        'rgba(237,214,102,1)',
                        'rgba(77,168,222,1)',
                        'rgba(25,168,164,1)',
                      ],
                      chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
                    },
                  },
                  ChartsData: {
                    lable: '数据接入',
                    propertyComponentName: 'ChartsDataConfigor',
                    value: {
                      currenEntry: 'staticData',
                      apiData: {
                        apiUrl:
                          'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
                        apiResponseQuery: 'data.forecasts',
                        isUseFilter: true,
                        apiFilter:
                          "\n          // 可以使用data访问api请求的响应结果\nlet seriesList = []\n\nlet seriesListKey = 'city'\nlet seriesListChildrenKey = 'casts'\n\ndata.forEach((item) => {\n  seriesList.push(item[seriesListKey])\n})\ndataSet.seriesList = seriesList\ndataSet.source = []\ndata.forEach((item) => {\n  item[seriesListChildrenKey].forEach(item2 => {\n    dataSet.source.push({\n      s: item[seriesListKey],\n      x: item2.date,\n      y: item2.daytemp\n    })\n  })\n})\n          ",
                        isUseInterval: true,
                        apiInterval: 10,
                      },
                      staticData: {
                        seriesList: ['杭州市'],
                        source: [
                          {
                            s: '杭州市',
                            x: '2021-05-21',
                            y: '25',
                          },
                          {
                            s: '杭州市',
                            x: '2021-05-22',
                            y: '133',
                          },
                          {
                            s: '杭州市',
                            x: '2021-05-23',
                            y: '20',
                          },
                          {
                            s: '杭州市',
                            x: '2021-05-24',
                            y: '27',
                          },
                        ],
                      },
                    },
                  },
                  posSize: {
                    lable: '位置尺寸',
                    propertyComponentName: 'ChartsPosSizeConfiger',
                    value: {
                      width: 300,
                      height: 150,
                      left: 72,
                      top: 83,
                    },
                  },
                  fontStyle: {
                    lable: '图表文字样式',
                    propertyComponentName: 'ChartsFontStyleConfiger',
                    value: {
                      titleSize: 16,
                      titleColor: '#ccc',
                      xAxisSize: 12,
                      xAxisColor: '#c3dbff',
                      yAxisSize: 12,
                      yAxisColor: '#c3dbff',
                    },
                  },
                  chartsGrid: {
                    lable: '图表定位',
                    propertyComponentName: 'ChartsGridConfiger',
                    value: {
                      left: '5%',
                      right: '5%',
                      bottom: '17%',
                      top: '12%',
                    },
                  },
                  showStatus: {
                    value: 'norm',
                  },
                  chartsOpicity: {
                    propertyComponentName: 'ChartsOpicityConfiger',
                    value: 1,
                  },
                  chartsAnimation: {
                    propertyComponentName: 'ChartsAnimationConfiger',
                    value: {
                      isUseAnimation: false,
                      isUseStaticRefresh: false,
                      staticRefreshIntervalTime: 3,
                    },
                  },
                },
              },
            ],
          },
          {
            id: 'JUaknLYRCkJ2T5gNcjjVb',
            IconPath: '/img/styles/menusIcons/menuIcon7.png',
            OverViewImg: './img/scene/scene.png',
            SceneName: '环境数据',
            Background: {},
            Style: {},
            Charts: [],
          },
        ],
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.getPublicTemplates();
      this.getPrivateTemplates();
    },
    handleReadyEdit(data) {
      console.log(data);
      this.currentEditData = data;
      this.templateAuth = data.allow_access_list;
      this.templateName = data.template_name;
      this.templateType = parseInt(data.type);
      this.isShowEditTemplate = true;
    },
    handleEditTemplate() {
      let templateData = '';
      templateData = this.currentEditData.template_data;

      templateData = templateData.replace(/^"/, '');
      templateData = templateData.replace(/"$/, '');

      // this.isUpdateTemplateData   更不更新模板数据
      if (this.isUpdateTemplateData === 1) {
        console.log('不修改数据');
        let params = {
          method: 'post',
          url: Api.modTemplate,
          data: {
            template_name: this.templateName,
            template_data: templateData,
            // image: '21111',
            type: this.templateType,
            allow_access_list: this.templateAuth,
            row_id: this.currentEditData.row_id,
          },
          headers: {
            'content-type': 'application/json',
          },
        };
        request(params).then(res => {
          console.log(res);
          this.$ElMessage.success('修改成功！');
          this.isShowEditTemplate = false;
          this.getData();
        });
      } else {
        console.log('修改数据');
        templateData = JSON.stringify(this.$store.state.ProjectInfo);

        let params = {
          method: 'post',
          url: Api.modTemplate,
          data: {
            template_name: this.templateName,
            template_data: templateData,
            // image: '21111',
            type: this.templateType,
            allow_access_list: this.templateAuth,
            row_id: this.currentEditData.row_id,
          },
          headers: {
            'content-type': 'application/json',
          },
        };
        request(params).then(res => {
          console.log(res);
          this.$ElMessage.success('修改成功！');
          this.isShowEditTemplate = false;
          this.getData();
        });
      }
    },
    handleConfirmDelete() {
      console.log(this.deleteId, '5445648444');
      let params = {
        method: 'post',
        url: Api.delTemplate + '&row_id=' + this.deleteId,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      };
      request(params).then(response => {
        console.log(response, 'response');
        this.$ElMessage.success('删除成功！');
        this.isShowDeleteTemplateConfirm = false;
        this.getData();
      });
    },

    handleReadyDelete(id) {
      console.log(id);
      this.deleteId = id;
      this.isShowDeleteTemplateConfirm = true;
    },
    chooseTemplate(data) {
      let ProjectData = data.template_data;
      ProjectData = ProjectData.replace(/^"/, '');
      ProjectData = ProjectData.replace(/"$/, '');

      let info = window.localStorage.getItem('origin_userInfo');

      let userinfo = JSON.parse(info);
      let newStr1;
      if (window.location.origin.substring(5, 16) == '//localhost') {
        newStr1 = ProjectData;
      } else {
        newStr1 = ProjectData.replace(
          /http:\/\/localhost:8080\/bigdatadisplaysystem_php\/back/g,
          window.location.origin,
        );
      }

      let newStr2 = newStr1.replace(/destination_id=75/g, `destination_id=${userinfo.destination_id}`);
      // newStr2 = newStr2.replace(/^"/, '');
      // newStr2 = newStr2.replace(/"$/, '');
      ProjectData = JSON.parse(newStr2);

      this.$store.commit('set_allProjectInfo', ProjectData);
      this.$store.commit('set_CurrentScene', ProjectData.SceneryList[0].id);
      this.$ElMessage.success('应用模板成功！');

      // 保存 对应 风格背景
      let bakData = JSON.stringify(ProjectData.Background);
      localStorage.setItem('backgroundDefault', JSON.stringify(bakData.Background));
    },
    applyTempleData() {
      const projectInfo = this.temp;
      this.$store.commit('set_allProjectInfo', projectInfo);
      // 更新当前场景id
      this.$store.commit('set_CurrentScene', projectInfo.SceneryList[0].id);
      // 保存项目id 用于提交修改项目数据到数据库
      // this.$store.commit('set_ProjectID', targetProjet.row_id);
      // this.$store.commit('set_ProjectPid', targetProjet.pid);
      // this.$store.commit('set_ProjectName', targetProjet.project_name);
    },
    getPublicTemplates() {
      let origin_userInfo = window.localStorage.getItem('origin_userInfo');
      // 检查本地登录原始用户信息是否存在
      if (!origin_userInfo) {
        this.$ElMessage.error('用户信息不存在，无法查询公共模板！');
        return;
      }
      origin_userInfo = JSON.parse(origin_userInfo);
      // 获取用户权限信息
      let params = {
        method: 'post',
        url: Api.getPubTemplate + '&auth_type=' + origin_userInfo.type,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      };
      request(params).then(response => {
        console.log('公共模板信息！');
        console.log(response);
        this.publicTemplates = [];
        if (response?.data?.list) {
          this.publicTemplates = response.data.list;
        }
      });
    },
    getPrivateTemplates() {
      let origin_userInfo = window.localStorage.getItem('origin_userInfo');
      // 检查本地登录原始用户信息是否存在
      if (!origin_userInfo) {
        this.$ElMessage.error('用户信息不存在，无法查询私有模板！');
        return;
      }
      origin_userInfo = JSON.parse(origin_userInfo);
      let params = {
        method: 'post',
        url: Api.getPrvTemplate + `&create_by=${origin_userInfo.row_id}`,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      };
      request(params).then(response => {
        console.log(response, '私有模板信息！');
        this.privateTemplates = [];
        if (response?.data?.list) {
          this.privateTemplates = response.data.list;
        }
      });
    },
  },
};
</script>

<style lang="scss">
body {
  .el-dialog.template-delete-dialog {
    background: rgb(32, 33, 43);

    .el-dialog__title {
      color: #ccc;
    }

    .el-dialog__body {
      // height: 50px;
      text-align: center;
      line-height: 50px;
      color: rgb(194, 200, 223);
    }

    .dialog-footer-btns {
      display: flex;
      align-items: center;
      justify-content: center;

      .el-button {
        width: 100px;
        color: #fff;
        border: 0;
      }

      .el-button:nth-child(1) {
        background-color: rgb(48, 50, 71);

        &:hover {
          background-color: rgb(39, 44, 63);
        }
      }

      .el-button:nth-child(2) {
        background-color: rgb(191, 40, 111);

        &:hover {
          background-color: rgb(145, 34, 86);
        }
      }
    }
  }

  .el-dialog.index-workbench-editTemplate-dialog {
    background: rgb(32, 33, 43);

    .el-dialog__title {
      color: #ccc;
    }

    .el-dialog__body {
      color: rgb(194, 200, 223);
      padding: 20px 30px;
      box-sizing: border-box;

      .add-template-info {
        width: 100%;

        .add-template-info-item {
          width: 100%;
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          .info-label {
            width: 20%;
          }
          .info-value {
            width: 80%;
            .el-input {
              width: 100%;
            }
            .el-radio__input.is-checked {
              .el-radio__inner {
                background: #3a52c4;
                border: 1px solid #759efe;
                &::after {
                  background: #3a52c4;
                }
              }
            }
            .el-radio__inner {
              background: #676767;
              border: 1px solid #676767;
              &::after {
                background: #676767;
              }
            }
            input {
              height: 30px;
              color: #b6b8cc;
              background: #191b23;
              text-align: center;
              border: 1px solid rgba(139, 139, 139, 0.733);
              &:focus {
                border: 1px solid rgb(77, 91, 255);
              }
            }
          }
        }
      }
    }

    .dialog-footer-btns {
      display: flex;
      align-items: center;
      justify-content: center;

      .el-button {
        width: 100px;
        color: #fff;
        border: 0;
      }

      .el-button:nth-child(1) {
        background-color: rgb(48, 50, 71);

        &:hover {
          background-color: rgb(39, 44, 63);
        }
      }

      .el-button:nth-child(2) {
        background-color: rgb(100, 86, 224);

        &:active {
          background-color: rgb(56, 63, 163);
        }
      }
    }
  }
}

body .el-autocomplete__popper.el-popper.screen_size_popper {
  background: #181a1f;
  border: 1px solid #575e62;

  & .el-popper__arrow::before {
    background: #181a1f;
    border: 1px solid #575e62;
  }
  & ul li {
    line-height: 25px;
    text-align: center;
    color: #b6b8cc;
  }
  & ul li:hover {
    background-color: #2c2e3f;
    color: #fff;
  }
}
</style>

<style lang="scss" scoped>
.l-m-templates {
  width: 240px;
  height: 100%;
  box-sizing: border-box;

  .el-container {
    box-sizing: border-box;
    width: 100%;
    height: 100%;

    .el-header {
      line-height: 40px;
      text-align: center;
      font-size: 14px;
      color: $font-color-base;
      user-select: none;
      background-color: #2c2e3f;
    }
    .el-main {
      &::-webkit-scrollbar-thumb {
        background: #191e29 !important;
        width: 4px !important;
        height: 3px !important;
      }
      &::-webkit-scrollbar {
        width: 4px !important;
        height: 3px !important;
      }
      &::-webkit-scrollbar-track {
        background: #43455800;
      }
      overflow-y: auto;
      width: 100%;
      height: 100%;
      padding: 15px;
      box-sizing: border-box;
      .public-templates {
        width: 100%;
      }
      .private-templates {
        width: 100%;
      }
      .templates-header {
        font-size: 14px;
        color: $font-color-base;
        user-select: none;
      }
      .templates-body {
        width: 100%;
        padding-top: 18px;
        .templates-item {
          position: relative;
          &:hover > .edit-template {
            color: #ccc;
            background-color: #191e2900;
          }
          .edit-template {
            cursor: pointer;
            width: 30px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            color: #00000000;
            top: 4px;
            right: 4px;
            position: absolute;
            &:hover {
              color: #ccc;
              box-shadow: 1px 1px 4px 1px #191e29b4;
              background-color: #0f11166b;
            }
          }

          &:hover > .delete-template {
            color: #ccc;
            background-color: #191e2900;
          }
          .delete-template {
            cursor: pointer;
            width: 30px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            color: #00000000;
            bottom: 35px;
            right: 4px;
            position: absolute;
            &:hover {
              color: #ccc;
              box-shadow: 1px 1px 4px 1px #191e29b4;
              background-color: #0f11166b;
            }
          }

          &:hover > .apple-btn {
            display: block;
          }
          .apple-btn {
            display: none;
            left: 50%;
            transform: translateX(-50%);
            top: 30%;
            position: absolute;
            z-index: 1;
            border-radius: 1px;
            color: #ffffff;
            border: 0;
            background: linear-gradient(143deg, #335ae9, #6f6ff5);

            &:hover {
              background: linear-gradient(143deg, #2c51d8, #5959d1);
              color: white;
            }
          }

          &:hover > .templates-item-image {
            border: 1px solid rgb(70, 59, 226);
            img {
              opacity: 0.5;
            }
          }

          cursor: pointer;
          width: 100%;
          margin-bottom: 5px;
          border-radius: 10px;
          box-sizing: border-box;

          .templates-item-image {
            width: 100%;
            height: 120px;
            background-color: rgba(20, 20, 27, 0.733);
            transition: border 0.2s;
            border: 1px solid rgba(0, 0, 0, 0);
            border-radius: 5px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .templates-item-name {
            width: 100%;
            height: 30px;
            line-height: 30px;
            text-align: center;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
